import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header.js";
import LoginSideMenu from "../components/LoginSideMenu.js";
import OverlayManager from "../components/OverlayManager";
import WelcomeScreen from "../components/WelcomeScreen";
import PromoHeader from "../components/PromoHeader.js";
import PricingTable from "../components/PricingTable.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { checkAuthStatus } from "../helpers/authUtils.js";
import {
  useUI,
  useMenu,
  useAuth,
  useResponsiveLayout,
} from "../hooks/index.js";
import { baseBackendURL } from "../helpers/baseUrl.js";
import { captureGclid } from "../helpers/conversionUtils.js";
import "../styles/App.css";

const HomePage = () => {
  const navigate = useNavigate();

  const { isMobile, setIsMobile, appLoaded, setAppLoaded, setIsFullWidth } =
    useUI();
  const {
    showSubscriptionMenu,
    setShowSubscriptionMenu,
    overlayContent,
    setOverlayContent,
    handleOverlayClose,
    toggleMenu,
    setMenuOpen,
  } = useMenu();
  const {
    email,
    isRegistering,
    setIsRegistering,
    setReferrer,
    setIsSettingNewPassword,
  } = useAuth();

  const loggedIn = !!email;

  const [showIntroFlag, setShowIntroFlag] = useState(true);

  // Initialize states
  useEffect(() => {
    const resetTokenParam = new URLSearchParams(window.location.search).get(
      "rt",
    );
    if (resetTokenParam) {
      setMenuOpen(true);
      setIsSettingNewPassword(true);
    }
  }, [setMenuOpen, setIsSettingNewPassword]);

  /* Effects
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setIsMobile]); */

  useEffect(() => {
    const referrer = new URLSearchParams(window.location.search).get("ref");
    if (referrer) setReferrer(referrer);
  }, [setReferrer]);

  // Check if user is already logged in and redirect to app
  useEffect(() => {
    const checkAuth = async () => {
      const resetTokenParam = new URLSearchParams(window.location.search).get(
        "rt",
      );
      if (resetTokenParam) {
        setAppLoaded(true);
        return;
      }

      const { isAuthenticated } = await checkAuthStatus();
      if (isAuthenticated) {
        navigate("/app");
      } else {
        setAppLoaded(true);
      }
    };
    checkAuth();
  }, [navigate, setAppLoaded]);

  /* Event Tracking */
  useEffect(() => {
    captureGclid();
  }, []);

  useEffect(() => {
    if (overlayContent && window.gtag) {
      window.gtag("event", "page_view", {
        page_title: overlayContent,
        page_path: `/${overlayContent}`,
      });
    }
  }, [overlayContent]);

  useResponsiveLayout(setIsMobile, setIsFullWidth);

  useEffect(() => {
    if (isRegistering && window.gtag) {
      window.gtag("event", "begin_registration");
    }
  }, [isRegistering]);

  if (!appLoaded) {
    return <div> Loading... </div>;
  }

  return (
    <div className="App">
      <PromoHeader
        onButtonClick={() => {
          setShowSubscriptionMenu((prev) => !prev);
        }}
      />
      <Header loggedIn={false} />

      <LoginSideMenu />

      <OverlayManager
        overlayContent={overlayContent}
        handleOverlayClose={handleOverlayClose}
      />

      <main className="main-content homepage-content">
        {showSubscriptionMenu ? (
          <div>
            <button
              className="go-back-button"
              onClick={() => setShowSubscriptionMenu(false)}
            >
              ← Back
            </button>
            <PricingTable currentSubscription={null} />
          </div>
        ) : (
          <WelcomeScreen
            setOverlayContent={setOverlayContent}
            setIsRegistering={setIsRegistering}
            toggleMenu={toggleMenu}
          />
        )}
      </main>

      <ToastContainer
        position="top-center"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default HomePage;
